import { Config } from "../../Config";
import axios from "axios";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function fetchVapidPublicKey(token: string): Promise<string | null> {
  try {
    const response = await axios.get(
      `${Config.API_URL}/push-subscription/vapid-public-key`,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return response.data.publicKey;
  } catch (error) {
    console.error("Failed to fetch VAPID public key:", error);
    return null;
  }
}

export async function subscribeToPush(
  registration: ServiceWorkerRegistration,
  vapidPublicKey: string
): Promise<PushSubscription | null> {
  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });
    return subscription;
  } catch (error) {
    console.error("Push subscription failed:", error);
    return null;
  }
}

export async function sendSubscriptionToBackend(
  subscription: PushSubscription,
  token: string
): Promise<boolean> {
  try {
    const json = subscription.toJSON();
    await axios.post(
      `${Config.API_URL}/push-subscription/subscribe`,
      {
        endpoint: subscription.endpoint,
        keys: {
          p256dh: json.keys?.p256dh ?? "",
          auth: json.keys?.auth ?? "",
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Failed to send subscription to backend:", error);
    return false;
  }
}

export async function removeSubscriptionFromBackend(
  endpoint: string,
  token: string
): Promise<boolean> {
  try {
    await axios.delete(`${Config.API_URL}/push-subscription/unsubscribe`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: { endpoint },
    });
    return true;
  } catch (error) {
    console.error("Failed to remove subscription from backend:", error);
    return false;
  }
}
